import type { ReactNode } from 'react';
import { AppShell, Content } from '../../components/ui/AppShell';

/**
 * The immersive dark surface every fixture detail wears — the same night gradient
 * as the make-picks / live-board screens, so the whole fixture flow reads as one
 * dark world. The glowing match/duel header card sits right under the back bar and
 * provides the green/amber halo, so the shell itself stays a clean dark fill.
 */
export function FixtureShell({ children }: { children: ReactNode }) {
  return (
    <AppShell surfaceClassName="bg-[linear-gradient(179deg,#1A1A22_0%,#0C0C11_58%,#08080C_100%)] md:bg-none md:bg-canvas">
      <div className="relative min-h-full bg-[linear-gradient(179deg,#1A1A22_0%,#0C0C11_58%,#08080C_100%)] text-white">
        <Content>{children}</Content>
      </div>
    </AppShell>
  );
}
